<div class="ticket">
  <!-- HEADER -->
  <div class="center bold">
    <div>BORA TASTY FOOD</div>
    <div class="small">Pedido</div>
  </div>

  <hr />

  <!-- INFO PEDIDO -->
  <div class="row">
    <span>Pedido:</span>
    <span class="bold">{{ data.orderCode }}</span>
  </div>

  <div class="row">
    <span>Fecha:</span>
    <span>{{ data.createdAt | date: "dd/MM HH:mm" }}</span>
  </div>

  <div class="row">
    <span>Cliente:</span>
    <span>{{ data.customerName }}</span>
  </div>

  <div class="row">
    <span>Tel:</span>
    <span>{{ data.customerPhone }}</span>
  </div>

  <div class="row">
    <span>Tipo:</span>
    <span>
      {{ data.deliveryType === 1 ? "Delivery" : "Retiro" }}
    </span>
  </div>

  <div *ngIf="data.deliveryAddress">
    <div class="bold">Dirección:</div>
    <div>{{ data.deliveryAddress }}</div>
  </div>

  <hr />

  <!-- ITEMS -->
  <div class="bold">Detalle</div>

  <div *ngFor="let item of data.items" class="item">
    <!-- Producto -->
    <div class="row">
      <span class="bold">{{ item.productName }}</span>
      <span>${{ item.unitPrice }}</span>
    </div>

    <!-- Precio base -->
    <div class="small">Precio base: ${{ item.unitPrice }}</div>

    <!-- Toppings -->
    <div *ngIf="item.toppings?.length" class="toppings">
      <div *ngFor="let topping of item.toppings" class="row small">
        <span>
          + {{ topping.toppingName }}
          <ng-container *ngIf="topping.quantity > 1">
            (x{{ topping.quantity }})
          </ng-container>
        </span>
        <span>${{ topping.subtotal }}</span>
      </div>
    </div>

    <!-- Notas -->
    <div *ngIf="item.notes" class="small italic">Notas: {{ item.notes }}</div>
  </div>

  <hr />

  <!-- TOTALES -->
  <div class="row">
    <span>Subtotal</span>
    <span>${{ data.subtotalAmount }}</span>
  </div>

  <div class="row">
    <span>Envío</span>
    <span>${{ data.deliveryFee }}</span>
  </div>

  <div class="row bold">
    <span>Total</span>
    <span>${{ data.totalAmount }}</span>
  </div>

  <hr />

  <!-- FOOTER -->
  <div class="center small">¡Gracias por tu compra!</div>
</div>
